import styled from 'styled-components'

export const Wrapper = styled.section`
  background: white;
  border: 1px solid black;
  width: 80%;
  padding: 2em;
  margin: 0 auto;
`

export const Title = styled.h1`
  color: black;
  font-size: 30px;
  margin: 0;
`

export const Button = styled.button`
  border-radius: 4px;
  border: 1px solid #ccc;
  padding: 5px 10px;
  margin: 10px 20px;
  cursor: pointer;
  background-color: ${({ backgroundColor }) =>
    backgroundColor ? backgroundColor : `grey`};
  color: ${({ textColor }) => (textColor ? textColor : `white`)};
  &:focus {
    background: ${({ backgroundFocusColor }) =>
      backgroundFocusColor ? backgroundFocusColor : `#ddd;`};
  }
`

export const LargeButton = styled(Button)`
  font-size: 20px;
`
